export type SchedulingRestrictionsDto = {
    bookMaxDaysInAdvance: number
    bookMinBeforeStartTime: number
    canCancel: boolean
    canResched: boolean
    cancelMinBeforeStartTime: number
    id?: string
    locationId?: string
    reschedMinBeforeStartTime: number
    serviceIds?: string[]
    staffId?: string
    tenantId: string
    type: string
    lookupId: string
}

export enum LimitType {
    STAFF = "STAFF",
    SERVICE = "SERVICE"
}

export type SchedulingLimitDTO = {
    id?: string
    lookupId: string
    maxCountPerDay?: number
    maxCountPerWeek?: number
    maxMinutesPerDay?: number
    maxMinutesPerWeek?: number
    type: LimitType
}

export type SchedulingLimit = {
    id?: string
    lookup_id: string
    max_count_per_day?: number
    max_count_per_week?: number
    max_hours_per_day?: number
    max_hours_per_week?: number
    type: LimitType
}

export function mapSchedulingLimitFromDTO(dto: SchedulingLimitDTO): SchedulingLimit {
    return {
        id: dto.id,
        lookup_id: dto.lookupId,
        max_count_per_day: dto.maxCountPerDay,
        max_count_per_week: dto.maxCountPerWeek,
        max_hours_per_day: (dto.maxMinutesPerDay || 0) / 60,
        max_hours_per_week: (dto.maxMinutesPerWeek || 0) / 60,
        type: dto.type
    }
}

export function mapSchedulingLimitToDTO(limit: SchedulingLimit): SchedulingLimitDTO {
    return {
        id: limit.id,
        lookupId: limit.lookup_id,
        maxCountPerDay: limit.max_count_per_day,
        maxCountPerWeek: limit.max_count_per_week,
        maxMinutesPerDay: (limit.max_hours_per_day || 0) * 60,
        maxMinutesPerWeek: (limit.max_hours_per_week || 0) * 60,
        type: limit.type
    }
}